import { render, staticRenderFns } from "./dingd-list.vue?vue&type=template&id=19b0e828&scoped=true"
import script from "./dingd-list.vue?vue&type=script&lang=js"
export * from "./dingd-list.vue?vue&type=script&lang=js"
import style0 from "./dingd-list.vue?vue&type=style&index=0&id=19b0e828&prod&scoped=true&lang=css"
import style1 from "./dingd-list.vue?vue&type=style&index=1&id=19b0e828&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b0e828",
  null
  
)

export default component.exports